import XLSX from "xlsx-style"
import Cell = XlsxStyle.Cell

import {Map} from "immutable"

import {Divisions, JsonData as DivisionJsonData, fromJs, Division} from "./../model/Division"
import {User} from "./../model/User"
import {Role} from "./../model/User"

import {
    composeSheetData,
    createWorkbook,
    addWorksheet,
    addFilter,
    composeXlsx,
    getStream,
} from "./../Excel/export"
import {Companies, Company} from "../model/Company";
import {CellData, RowData} from "../model/utils/utils";
import {logger} from "../utils/logger";

type JsonData = {
    division: DivisionJsonData[]
}

enum Rows {
    id = 0,
    type,
    title,
    role,
    region,
    city,
    crmAccessRequested,
    crmLogged,
    confirmed,
    demandHold,
    hiPoHold,
    financeLocked,
    demandLocked,
    demandBuildingLocked,
    hiPoLocked,
    crmExported,
    crmPrinted,
    crmSentMessage,
    crmSentResult,
/*
    executorName,
    executorPosition,
    executorContacts,
    chiefName,
    chiefPosition,
    productionName,
    productionPosition,
*/
}

const lpad = (n: number) => `0000${n}`.substr(-4, 4)
const yesNo = (a: number | boolean): string => !!a ? "Да" : "Нет"

const heading: RowData = {
    [Rows.id]: "#",
    [Rows.type]: "Вид пользователя",
    [Rows.title]: "Название",
    [Rows.role]: "Вид внесения данных",
    [Rows.region]: "Регион",
    [Rows.city]: "Город",
    [Rows.crmAccessRequested]: "Запросил логин и пароль",
    [Rows.crmLogged]: "Зашел на ресурс",
    [Rows.confirmed]: "Отредактировал личные данные",
    [Rows.demandHold]: "Отправил данные по общ потребностям на согласование",
    [Rows.hiPoHold]: "Отправил данные по HiPo на согласование",
    [Rows.financeLocked]: "Отправил данные по финанси-рованию вузов",
    [Rows.demandLocked]: "Получил согласование дивизиона по общим потребностям",
    [Rows.demandBuildingLocked]: "Получил соголасование ОЦКС по общим потребностям строительных специальностей",
    [Rows.hiPoLocked]: "Получил согласование дивизиона по HiPo",
    [Rows.crmExported]: "Составил предварительный отчет",
    [Rows.crmPrinted]: "Составил итоговый отчет",
    [Rows.crmSentMessage]: "Отправил сообщение об ошибке",
    [Rows.crmSentResult]: "Прислал скан",
/*
    [Rows.executorName]: "Ответственный ФИО",
    [Rows.executorPosition]: "Ответственный должность",
    [Rows.executorContacts]: "Ответственный Контактная информация",
    [Rows.chiefName]: "HR-директор ФИО",
    [Rows.chiefPosition]: "HR-директор название должности",
    [Rows.productionName]: "Директор предприятия/Дивизиона ФИО",
    [Rows.productionPosition]: "Директор предприятия/Дивизиона название должности",
*/
}

const encodeDataColumn = (c: Rows, r: number): string => XLSX.utils.encode_range({c, r: 1}, {c, r})

const footer = (count: number): RowData => ({
    [Rows.id]: "",
    [Rows.type]: "ИТОГО",
    [Rows.title]: "",
    [Rows.role]: "",
    [Rows.region]: "",
    [Rows.city]: "",
    [Rows.crmAccessRequested]:      {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmAccessRequested,    count)}, "Да")`},
    [Rows.crmLogged]:               {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmLogged,             count)}, "Да")`},
    [Rows.confirmed]:               {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.confirmed,             count)}, "Да")`},
    [Rows.demandHold]:              {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.demandHold,            count)}, "Да")`},
    [Rows.hiPoHold]:                {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.hiPoHold,              count)}, "Да")`},
    [Rows.financeLocked]:           {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.financeLocked,         count)}, "Да")`},
    [Rows.demandLocked]:            {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.demandLocked,          count)}, "Да")`},
    [Rows.demandBuildingLocked]:    {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.demandBuildingLocked,  count)}, "Да")`},
    [Rows.hiPoLocked]:              {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.hiPoLocked,            count)}, "Да")`},
    [Rows.crmExported]:             {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmExported,           count)}, "Да")`},
    [Rows.crmPrinted]:              {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmPrinted,            count)}, "Да")`},
    [Rows.crmSentMessage]:          {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmSentMessage,        count)}, "Да")`},
    [Rows.crmSentResult]:           {t: "n", f: `COUNTIF(${encodeDataColumn(Rows.crmSentResult,         count)}, "Да")`},
/*
    [Rows.executorName]: "",
    [Rows.executorPosition]: "",
    [Rows.executorContacts]: "",
    [Rows.chiefName]: "",
    [Rows.chiefPosition]: "",
    [Rows.productionName]: "",
    [Rows.productionPosition]: "",
*/
})

const makeEmptyRow = (): RowData => ({
    [Rows.id]: "",
    [Rows.type]: "",
    [Rows.title]: "",
    [Rows.role]: "",
    [Rows.region]: "",
    [Rows.city]: "",
    [Rows.crmAccessRequested]: "",
    [Rows.crmLogged]: "",
    [Rows.confirmed]: "",
    [Rows.demandHold]: "",
    [Rows.hiPoHold]: "",
    [Rows.financeLocked]: "",
    [Rows.demandLocked]: "",
    [Rows.demandBuildingLocked]: "",
    [Rows.hiPoLocked]: "",
    [Rows.crmExported]: "",
    [Rows.crmPrinted]: "",
    [Rows.crmSentMessage]: "",
    [Rows.crmSentResult]: "",
/*
    [Rows.executorName]: "",
    [Rows.executorPosition]: "",
    [Rows.executorContacts]: "",
    [Rows.chiefName]: "",
    [Rows.chiefPosition]: "",
    [Rows.productionName]: "",
    [Rows.productionPosition]: "",
*/
})

type DivisionData = {
    id?: number
    title?: string
}

type CompanyData = {
    division: DivisionData
    division2?: DivisionData
    company?: {
        id?: number
        abbreviation: string
        region: string
        city: string
        crmAccessRequested: boolean
        demandHold: boolean
        demandLocked: boolean
        demandBuildingLocked: boolean
        crmSentResult: boolean
        crmExported: boolean
        crmPrinted: boolean
        hasBuildingDemands: boolean
    }
}

const composeUserRows = (
    {
        id: userId,
        role,
        crmLogged,
        confirmed,
        crmSentMessage,
        executor,
        chief,
        production,
    }: User,
    {
        division: {
            id: division1Id,
            title: division1Title,
        },
        division2: {
            id: division2Id,
            title: division2Title,
        } = {
            id: undefined,
            title: undefined,
        },
        company: {
            id: companyId,
            abbreviation: companyTitle,
            region,
            city,
            crmAccessRequested,
            demandHold,
            demandLocked,
            demandBuildingLocked,
            crmSentResult,
            crmExported,
            crmPrinted,
            hasBuildingDemands,
        } = {
            id: undefined,
            abbreviation: "",
            region: "",
            city: "",
            crmAccessRequested: false,
            demandHold: false,
            demandLocked: false,
            demandBuildingLocked: false,
            crmSentResult: false,
            crmExported: false,
            crmPrinted: false,
            hasBuildingDemands: false,
        },
    }: CompanyData
): RowData[] => {
    let rawResult: RowData[] = []

    let row = makeEmptyRow()

    row[Rows.id] = [division1Id, division2Id, companyId, userId].map(a => (a || 0)).map(lpad).join(".")
    row[Rows.type] = (companyId === undefined) ? "Division" : "Company"
    row[Rows.role] = Role[role]
    row[Rows.title] = companyTitle || division2Title || division1Title || ""
    row[Rows.region] = region
    row[Rows.city] = city
    row[Rows.crmAccessRequested] = yesNo(crmAccessRequested)
    row[Rows.crmLogged] = yesNo(crmLogged)
    row[Rows.confirmed] = yesNo(confirmed)
    row[Rows.hiPoHold] = ""
    row[Rows.hiPoLocked] = ""
    row[Rows.crmExported] = yesNo(crmExported)
    row[Rows.crmPrinted] = yesNo(crmPrinted)
    row[Rows.crmSentMessage] = yesNo(crmSentMessage)
    row[Rows.crmSentResult] = yesNo(crmSentResult)

    switch (role) {
        case Role.Company:
            row[Rows.demandHold] = yesNo(demandHold)
            row[Rows.demandLocked] = yesNo(demandLocked)
            row[Rows.financeLocked] = ""

            if (hasBuildingDemands && demandHold) {
                row[Rows.demandBuildingLocked] = yesNo(demandBuildingLocked)
            }

            break
    }

/*
    if (executor) {
        row[Rows.executorName] = executor.fullName
        row[Rows.executorPosition] = executor.position

        if (executor.contacts) {
            row[Rows.executorContacts] = executor.contacts.toArray().join(",")
        }
    }

    if (chief) {
        row[Rows.chiefName] = chief.fullName
        row[Rows.chiefPosition] = chief.position
    }

    if (production) {
        row[Rows.productionName] = production.fullName
        row[Rows.productionPosition] = production.position
    }
*/

    rawResult.push(row)

    return rawResult
}

const composeCompaniesRows = (companies: Companies, {division, division2 = undefined}: {
    division: DivisionData
    division2?: DivisionData
}) => {
    let rawResult: RowData[] = []

    companies.map(({
        id,
        abbreviation,
        users,
        region,
        city,
        crmAccessRequested,
        demandHold,
        demandLocked,
        demandBuildingLocked,
        crmSentResult,
        crmExported,
        crmPrinted,
        hasBuildingDemands,
    }: Company) => {
        const company = {
            id,
            abbreviation,
            region,
            city,
            crmAccessRequested,
            demandHold,
            demandLocked,
            demandBuildingLocked,
            crmSentResult,
            crmExported,
            crmPrinted,
            hasBuildingDemands,
        }

        users
            ? users.map((user: User) => {
                rawResult = rawResult.concat(composeUserRows(user, {division, division2, company}))
            })
            : console.log("no users", id)
    })

    return rawResult
}

const composeData = (divisions: Divisions): CellData[][] => {
    let rawResult: RowData[] = []

    divisions.map(({
        id,
        title,
        users,
        divisions,
        companies,
    }: Division) => {
        let division = {
            id,
            title,
        }

        users
            ? users.map((user: User) => {
                rawResult = rawResult.concat(composeUserRows(user, {division}))
            })
            : console.log("no users", id)

        divisions && divisions.map(({id, title, users, companies}: Division) => {
            const division2 = {
                id,
                title,
            }

            users
                ? users.map((user: User) => {
                    rawResult = rawResult.concat(composeUserRows(user, {division, division2}))
                })
                : console.log("no users", id)

            companies && (rawResult = rawResult.concat(composeCompaniesRows(companies, {division, division2})))


        })

        companies && (rawResult = rawResult.concat(composeCompaniesRows(companies, {division})))
    })

    return rawResult.map(a => Object.keys(a).map(b => a[b]))
}

const exportXlsx = (data: JsonData) => {
    const divisions = <Divisions>Map(data.division.map(division => [division.id, fromJs(division)]))

    const sheetData = composeData(divisions)
    const sheetFooter = footer(sheetData.length)
    const sheetName = "CRM"

    let wb = createWorkbook()

    let ws = composeSheetData(
        [<CellData[]>Object.keys(heading).map(k => heading[k]).map((v): Cell => ({v, s: {font: {bold: true}}}))]
            .concat(sheetData)
            .concat([Object.keys(sheetFooter).map(k => sheetFooter[k])])
    )

    wb = addWorksheet(wb, ws, sheetName)

    let zip = composeXlsx(wb)
    zip = addFilter(zip, sheetData[0].length)

    getStream(zip, sheetName)
    console.timeEnd("export")
}

export const exportCrm = () => {
    console.time("export")
    fetch("/admin/division/export", {credentials: "include"})
        .then(response => response.json())
        .then<JsonData>(response => response as any)
        .then(exportXlsx)
        .catch(error => logger.captureException(error))
}
